module.exports = __webpack_public_path__ + "fonts/DB Helvethaica X Med v3.2.27f6aaf.ttf";